import { gql, useQuery } from "@apollo/client";

export type EpocusOpsAuditActorKind = "HUMAN" | "MACHINE";
export type EpocusOpsAuditOutcome = "SUCCESS" | "FAILURE";

export type EpocusOpsAuditEvent = {
  readonly id: string;
  readonly occurredAt: string;
  readonly actorKind: EpocusOpsAuditActorKind;
  readonly actorId: string;
  readonly onBehalfOfId: string | null;
  readonly operation: string;
  readonly outcome: EpocusOpsAuditOutcome;
  readonly failureReason: string | null;
  readonly entityId: string | null;
  readonly detail: unknown;
};

export type EpocusProgramAuditTrailQuery = {
  readonly epocusProgramAuditTrail: {
    readonly enabled: boolean;
    readonly events: readonly EpocusOpsAuditEvent[];
  };
};

export type EpocusProgramAuditTrailQueryVariables = {
  readonly programId: string;
  readonly limit?: number;
};

export const EPOCUS_PROGRAM_AUDIT_TRAIL = gql`
  query EpocusProgramAuditTrail($programId: ID!, $limit: Int) {
    epocusProgramAuditTrail(programId: $programId, limit: $limit) {
      enabled
      events {
        id
        occurredAt
        actorKind
        actorId
        onBehalfOfId
        operation
        outcome
        failureReason
        entityId
        detail
      }
    }
  }
`;

export const useEpocusProgramAuditTrailQuery = (
  variables: EpocusProgramAuditTrailQueryVariables,
  options: { skip?: boolean } = {},
) =>
  useQuery<EpocusProgramAuditTrailQuery, EpocusProgramAuditTrailQueryVariables>(
    EPOCUS_PROGRAM_AUDIT_TRAIL,
    {
      variables,
      skip: options.skip,
      fetchPolicy: "cache-and-network",
    },
  );
